import { USER_LOGIN,USER_LOGOUT } from "./types";

export function userLogin(token, role, refreshToken,user,isAuthenticated){
    return {
        type: USER_LOGIN,
        token,
        role,
        refreshToken,
        user,
        isAuthenticated
    };
}

export function userLogout() {
    localStorage.removeItem('auth');
    return {
      type: USER_LOGOUT,
    };
}